module.exports = __webpack_public_path__ + "static/media/video-retail-virtualization.a82d6560.mp4";